import { collection, query, where, getDocs, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';

export const startConversation = async (currentUser, otherUser) => {
  if (currentUser.uid === otherUser.uid) {
    throw new Error("You cannot message yourself");
  }

  const q = query(
    collection(db, 'conversations'),
    where('participants', 'array-contains', currentUser.uid)
  );

  const snapshot = await getDocs(q);
  const existingConv = snapshot.docs.find((docSnap) => {
    const participants = docSnap.data().participants;
    return participants.includes(otherUser.uid);
  });

  if (existingConv) {
    return existingConv.id;
  }

  const newConvData = {
    participants: [currentUser.uid, otherUser.uid],
    participantNames: {
      [currentUser.uid]: currentUser.displayName,
      [otherUser.uid]: otherUser.displayName
    },
    participantAvatars: {
      [currentUser.uid]: currentUser.photoURL || '',
      [otherUser.uid]: otherUser.photoURL || ''
    },
    lastUpdatedAt: serverTimestamp(),
    unreadCount: {
      [currentUser.uid]: 0,
      [otherUser.uid]: 0
    }
  };

  const docRef = await addDoc(collection(db, 'conversations'), newConvData);
  return docRef.id;
};
